const reviewWidget = document.querySelector('[data-reviews-widget]');
const mobileAnchor = document.querySelector('[data-reviews-widget-mobile-anchor]');

if (reviewWidget && mobileAnchor) {
  const mobileBreakpoint = window.matchMedia('(max-width: 749px)');
  const desktopPosition = document.createComment('Reviews widget desktop position');

  reviewWidget.before(desktopPosition);

  const updateReviewWidgetPosition = () => {
    if (mobileBreakpoint.matches) {
      reviewWidget.classList.remove('mobile:hidden');
      mobileAnchor.before(reviewWidget);
      return;
    }

    reviewWidget.classList.add('mobile:hidden');
    desktopPosition.after(reviewWidget);
  };

  updateReviewWidgetPosition();
  mobileBreakpoint.addEventListener('change', updateReviewWidgetPosition);
}
